import PropTypes from "prop-types"
import React, { useState, useRef, useEffect } from "react"

import {
  Container,
  Table,
  Card,
  CardBody,
  Collapse,
  Button,
  TabContent,
  TabPane,
  Nav,
  Row,
  Col,
  NavItem,
  NavLink,
  Label,
  Modal,
  Form,
  Input,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Tooltip,
} from "reactstrap"

import Loader from "react-spinner-loader"
import { useFormik } from "formik"
import * as yup from "yup"
import { ToastContainer, toast } from "react-toastify"


import { useNavigate, useLocation, Link } from "react-router-dom"

import Select from "react-select"

import "chartist/dist/scss/chartist.scss"

//i18n
import { withTranslation } from "react-i18next"
//class

import classnames from "classnames"
import awicon from "../../assets/images/services-icon/coin.png"

//popup
import axios from "axios"
import { SECURITY_KEY, BASE_URL, optionCoin, LCMS_API_BASE_URL } from "../../global"
import { MathJax, MathJaxContext } from "better-react-mathjax"
import {
  getAuthToken,
  getEffectiveTutorKey,
  getActAsTutorName,
  isAdminMode,
  shouldBlockWorkApi,
  isAdminShellBlockedError,
  TUTOR_ADMIN_VIEW_CHANGED,
} from "../../common/auth/tutor-admin-auth"
const CreateSummative = props => {
  const navigate = useNavigate()

  const [subjectIdData, setSubjectIdData] = useState(1)
  const [countryId, setCountryId] = useState(localStorage.getItem('country'))
  const [centKey, setCentKey] = useState(localStorage.getItem('cent_key'))
  const [tutKey, setTutKey] = useState(getEffectiveTutorKey())
  const [adminViewName, setAdminViewName] = useState(getActAsTutorName() || "")
  const adminMode = isAdminMode()
  const [yearlevelData, setYearlevelIdData] = useState(0)
  const [loader, setLoader] = useState(true)
  const formRef = useRef(null)

  const [subjectOptions, setSubjectOptions] = useState([])
  const [yearlevelOptions, setYearlevelOptions] = useState([{value: 0, label: 'All' }])



  const [existingData, setExistingValue] = useState(JSON.parse(localStorage.getItem("selectedSummative") || '[]') || [])
  
  const handleOnchangeGetSubject = event => {
    setSubjectIdData(event.value)
    setExistingValue([])
    localStorage.removeItem("selectedSummative")
   
      fetchSummativeTopicData(
        event.value,
        countryId
      )
   
  }

  const handleOnchangeGetYearlevel = event => {
    console.log(event)
    setYearlevelIdData(event.value)
    // setselectedGroupYearlevel(event.value)
  }
  
  //new level

  const [activityLevelData, setActivityLevelData] = useState(null)
  const [TotalQuestionValue, setTotalQuestionValue] = useState("");

  const fetchSubjectData = async () => {
    try {
      setLoader(true)
      if (shouldBlockWorkApi()) {
        setSubjectOptions([])
        setLoader(false)
        return
      }

      const token = getAuthToken()
      if (token && token != "" && token != null) {
        // setLoader(true);
        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`
        const response = await axios
          .post(BASE_URL + "mylibrary/getSubjectbySummative", {})
          .then(response_subject => {
            // Assuming the API response is an array of objects with 'id' and 'value' properties

            const formattedSubjectOptions = [
             
                  ...response_subject.data.map(option => ({
                    value: option.subject_id,
                    label: option.sub_name,
                  }))
               
            ]
            
           
            setSubjectOptions(formattedSubjectOptions)
            setSubjectIdData(formattedSubjectOptions[0]?.value)

            fetchSummativeTopicData(
              formattedSubjectOptions[0]?.value || 1,
              countryId
            )
            
          })
          .catch(error => {
            console.error("Error fetching options from API: ", error)

            setLoader(false)
          })
      } else {
        navigate("/login")
      } /*  */
      // setAllData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error)
    }
  }

  const fetchSummativeTopicData = async (
    subjectIdDataval,
    country_id
  ) => {
    setActiveIndex(null)
    setActivityLevelData(null)
    try {
      setLoader(true)

      if (shouldBlockWorkApi()) {
        setActivityLevelData(null)
        setLoader(false)
        return
      }

      const token = getAuthToken()
      if (token && token != "" && token != null) {
        
          setLoader(true)
          axios.defaults.headers.common["Authorization"] = `Bearer ${token}`
          const responseSummative = await axios.get(LCMS_API_BASE_URL + "summative/tree", {
              params: {
                subjectId: parseInt(subjectIdDataval),
                countryId: parseInt(country_id)
              }
            }).then(responseSummative => {

              if (responseSummative.status === 200) {
                const activitiesDatalevel = responseSummative.data;
                console.log("Success:", activitiesDatalevel);

                if(activitiesDatalevel?.data){

                  const initializeActivityData = (data) => {
                    return data.map((level) => ({
                      ...level,
                      selected: level.selected ?? false,
                      questionCount: level.questionCount ?? "",
                      topics: level.topics?.map((topic) => ({
                        ...topic,
                        selected: topic.selected ?? false,
                        questionCount: topic.questionCount ?? "",
                        activities: topic.activities?.map((activity) => ({
                          ...activity,
                          selected: activity.selected ?? false,
                          questionCount: activity.questionCount ?? "",
                        })) || [],
                      })) || [],
                    }));
                  };
                  
                  const formattedYearlevelOptions = [
                        ...activitiesDatalevel?.data.map(option => ({
                          value: option.levelId,
                          label: option.levelName,
                        })),
                      ];
                  formattedYearlevelOptions.unshift({
                    value: 0,
                    label: 'All'
                  });
                  setYearlevelOptions(formattedYearlevelOptions)
                  setYearlevelIdData(0)
                  setActivityLevelData(initializeActivityData(activitiesDatalevel?.data) || []);
                }else{
                  setActivityLevelData([]);
                }
                
              } else {
                toast.error("Activity details not found! Please try again.", {
                  autoClose: 3000, // 3 seconds
                });
              }
             
              setLoader(false)
            })
            .catch(error => {
              console.error("Error fetching options from API: ", error);
              if (
                (error?.response?.status === 403 || error?.response?.status === 401) &&
                (error?.response?.data?.errors?.[0]?.message === "invalid algorithm" || 
                  error?.response?.data?.errors?.[0]?.message === "jwt expired" || 
                  error?.response?.data?.errors?.[0]?.message === "invalid token" || 
                  error?.response?.data?.errors?.[0]?.message === "Not Authorized")
              ) {
                 // Server responded with a status other than 2xx
                 const errorMessages = error?.response?.data?.errors
                 ? error?.response?.data?.errors.map(err => err.message).join("\n")
                 : "An error occurred. Please try again.";
                 toast.error(`Error: ${errorMessages}`, {
                   autoClose: 3000, // 3 seconds
                   onClose: () => {
                    localStorage.clear();
                    navigate("/login");
                  },
                 });
              }else if (error.response) {
                // Server responded with a status other than 2xx
                const errorMessages = error?.response?.data?.errors
                  ? error?.response?.data?.errors.map(err => err.message).join("\n")
                  : "An error occurred. Please try again.";
                  toast.error(`Error: ${errorMessages}`, {
                    autoClose: 3000, // 3 seconds
                  });
                //alert(`Error: ${errorMessages}`);
              } else if (error.request) {
                // Request was made but no response received
                toast.error(`No response from server. Please check your internet connection.`, {
                  autoClose: 3000, // 3 seconds
                });
              } else {
                // Other errors toast.error("Activity details not found! Please try again.", {
                  
                //alert("An error occurred while making the request.");
              }
              setLoader(false)
            })
      
      } else {
        navigate("/login")
      } /*  */
      
    } catch (error) {
      console.error("Error fetching data:", error)
    }
  }

 
 
  useEffect(() => {
    fetchSubjectData()
  }, [])

  useEffect(() => {
    const handleAdminViewChanged = () => {
      setAdminViewName(getActAsTutorName() || "")
      setTutKey(getEffectiveTutorKey())
      fetchSubjectData()
    }

    window.addEventListener(TUTOR_ADMIN_VIEW_CHANGED, handleAdminViewChanged)
    return () => {
      window.removeEventListener(TUTOR_ADMIN_VIEW_CHANGED, handleAdminViewChanged)
    }
  }, [])
  

//hangel accordion start
  const [activeIndex, setActiveIndex] = useState(null)
  const [activeIndex1, setActiveIndex1] = useState(null)
  const toggleAccordion = (index, details) => {
    setActiveIndex(activeIndex === index ? null : index)
  }
  const [InnerLoder, setInnerLoder] = useState(false)
  const loaderRef = useRef(null)

  useEffect(() => {
    

    if (activeIndex) {
      const collapseElement = document.querySelector(
        ".tab-pane.active #accordion" + activeIndex + " .accordion-item"
      )

      if (collapseElement) {
        collapseElement.scrollIntoView({ behavior: "smooth", block: "start" })
      }
    }
  }, [InnerLoder, activeIndex]) // Dependency array includes InnerLoder

  const toggleAccordion1 = index => {
    setActiveIndex1(activeIndex1 === index ? null : index)
  }
 //hangel accordion end
  // Filter data for matches in actvity or topic_name start
  const [searchTerm, setSearchTerm] = useState("")
  
  const handleSearch = e => {
    setSearchTerm(e.target.value.toLowerCase())

    setActiveIndex1(0)
  }

  const highlightText = (text, term) => {
    if (!term) return text

    //const parts = text.split(new RegExp(`(${term})`, "gi"))
    const escapedTerm = term.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") // Escape special characters
    const parts = text.split(new RegExp(`(${escapedTerm})`, "gi"))
    return parts.map((part, index) =>
      part.toLowerCase() === term ? (
        <span key={index} style={{ backgroundColor: "yellow" }}>
          {part}
        </span>
      ) : (
        part
      )
    )
  }

// Filter data for matches in actvity or topic_name end

//prepare generate Criteria start
  const [existingDataCheck, setExistingDataCheck] = useState([]);
  const [questionData, setQuestionData] = useState([]);
  const [totalQuestion, settotalQuestion] = useState(0);
  
  const generateCriteria = (activityLevelData, setActivityLevelData, setExistingDataCheck, TotalQuestionValue) => {
    if (!activityLevelData || !Array.isArray(activityLevelData)) {
      return [];
    }
  
    let criteria = [];
    let updatedData = [...activityLevelData];
    let totalQuestionNeeded = TotalQuestionValue || 0;

    updatedData.forEach((level, levelIndex) => {
      let yearLevelValue = Number(level.questionCount) || 0; // Year Level max limit
      let totalTopicQuestions = 0;
      let lastUpdatedTopicIndex = -1;

      if( TotalQuestionValue && level.topics.some(topic => topic.selected && (!topic.questionCount || topic.questionCount === 0))){
        //totalQuestionNeeded += yearLevelValue;
      }else{
        // totalQuestionNeeded += level.topics.reduce(
        //   (sum, topic) => sum + (Number(topic.questionCount) || 0),
        //   0
        // );
        if(!TotalQuestionValue || TotalQuestionValue <= 0){
          totalQuestionNeeded += level.topics.reduce((sum, topic) => {
            const activityTotal = topic.activities.reduce(
              (aSum, activity) => aSum + (Number(activity.questionCount) || 0),
              0
            );
          
            return sum + (activityTotal > 0 ? activityTotal : Number(topic.questionCount) || 0);
          }, 0);  
        }     
      }
  
      // Calculate the total topic question count and track the last updated topic index
      level.topics.forEach((topic, topicIndex) => {
        let topicInputValue = Number(topic.questionCount) || 0;
        totalTopicQuestions += topicInputValue;
        if (topicInputValue > 0) {
          lastUpdatedTopicIndex = topicIndex;
        }
      });
  
      // If total exceeds the year level limit, reset only the last updated topic
      if (TotalQuestionValue > 0 && totalTopicQuestions > TotalQuestionValue && lastUpdatedTopicIndex !== -1) {
        // alert(
        //   `Total questions for topics (${totalTopicQuestions}) exceed the year-level limit (${yearLevelValue}). Resetting the last entered topic.`
        // );
        toast.error(`Total questions for topics (${totalTopicQuestions}) exceed the total question limit (${TotalQuestionValue}). Resetting the last entered topic.`, {
          autoClose: 3000, // 3 seconds
        });
  
        // Reset the last updated topic's value to 0
        updatedData[levelIndex].topics[lastUpdatedTopicIndex].questionCount = 0;
      }
  
      // Process topics for criteria
      level.topics.forEach((topic, topicIndex) => {
        let topicInputValue = Number(topic.questionCount) || 0;
  
        if (topic.selected && (topicInputValue > 0 || TotalQuestionValue > 0) && topic.activities.filter((activity) => activity.selected).length <= 0) {
        
          let questionsNeededLabelData = 0;
          if(TotalQuestionValue > 0 && topicInputValue <= 0){
            questionsNeededLabelData = 'Based on Total Qus';
          }
          criteria.push({
            type: "topic",
            referenceId: topic.topicId,
            questionsNeeded: questionsNeededLabelData === 0 ? topicInputValue : 0,
            topicLabel: topic.topicName,
            levelLabel: level.levelName,
            activityLabel: null,
            questionsNeededLabel: questionsNeededLabelData === 0 ? topicInputValue : questionsNeededLabelData,
          });
        }else{
          if(topic.selected && (topicInputValue >= 0 || TotalQuestionValue >= 0) && topic.activities.filter((activity) => activity.selected).length > 0){
            updatedData[levelIndex].topics[topicIndex].questionCount = '';
            updatedData[levelIndex].topics[topicIndex].selected = false;

            toast.error(`This topic is not selected because it contains selected activities.`, {
              autoClose: 3000, // 3 seconds
            });
          }
        }
  
         // Get the selected activities count for this topic
         let selectedActivities = topic.activities.filter((activity) => activity.selected);
        let activityCount = selectedActivities.length;
   
       if (activityCount > 0) {
        //   let perActivityValue =  0;
        //     if(topicInputValue > 0){
        //         perActivityValue = Math.floor(topicInputValue / activityCount);
        //     }else if(yearLevelValue > 0){
        //         perActivityValue = Math.floor(yearLevelValue / activityCount);
        //     }
     
        //    let remaining = topicInputValue % activityCount;
   
           // Distribute values to selected activities
           selectedActivities.forEach((activity, index) => {
            let activityInputValue = Number(activity.questionCount) || 0;
             //let finalValue = perActivityValue + (index === 0 ? remaining : 0); // Give remainder to first activity
             
            //  // Update the activity's input field
            //  updatedData[levelIndex].topics[topicIndex].activities.find(
            //    (a) => a.activityId === activity.activityId
            //  ).questionCount = finalValue;
   
             if ((activityInputValue > 0 || TotalQuestionValue > 0)) {
              let questionsNeededLabelData = activityInputValue || 0;
              
              if(TotalQuestionValue > 0 && activityInputValue <= 0){
                questionsNeededLabelData = 'Based on Year Qus';
              }
              // Push activity to criteria
              criteria.push({
                type: "activity",
                referenceId: activity.activityId,
                topicLabel: topic.topicName,
                levelLabel: level.levelName,
                activityLabel: activity.activityName,
                questionsNeeded: questionsNeededLabelData > 0 ? activityInputValue : 0,
                questionsNeededLabel: questionsNeededLabelData,
              });
            }
           });
         }
        
      });
    });
  
    // Update state only if an adjustment was made
    if(updatedData != activityLevelData){
      setActivityLevelData(updatedData);
      setExistingDataCheck(updatedData);
    }
    
   
    return {criteria, totalQuestionNeeded};
  };
  

  useEffect( () => {
    if(activityLevelData !== existingDataCheck){
    const {criteria, totalQuestionNeeded} = generateCriteria(activityLevelData, setActivityLevelData, setExistingDataCheck, TotalQuestionValue);
    //console.log(criteria)
    if(criteria && criteria.length > 0){
       settotalQuestion(totalQuestionNeeded || 0)
       setExistingValue(criteria)
      const jsonValue = JSON.stringify(criteria)
      localStorage.setItem("selectedSummative", jsonValue)
     
    }else{
      settotalQuestion(0)
      setQuestionData([])
      setExistingValue([])
      localStorage.setItem("selectedSummative", JSON.stringify([]))
    }
    }else if((parseInt(TotalQuestionValue) > 0 && parseInt(totalQuestion) != parseInt(TotalQuestionValue))){
      settotalQuestion(TotalQuestionValue)
    }
  }, [activityLevelData, TotalQuestionValue, totalQuestion])
//prepare generate Criteria end


//generated question based on Criteria start
  const fetchgenerateData = async() => {

    try {

      if (getAuthToken() && getAuthToken() != "" && getAuthToken() != null) {
        const requestData = {
          countryId: Number(countryId),
          subjectId: Number(subjectIdData),
          totalQuestionNeeded: Number(totalQuestion),
          // criteria: existingData.map(({ topicLabel, levelLabel, activityLabel, questionsNeededLabel, ...rest }) => rest)
          criteria: existingData.map(({ topicLabel, levelLabel, activityLabel, questionsNeededLabel, questionsNeeded, ...rest }) => {
            return {
              ...rest,
              ...(questionsNeeded !== 0 && { questionsNeeded }), // Only include if not 0
            };
          }),
          
        };
        axios.defaults.headers.common["Authorization"] = `Bearer ${getAuthToken()}`
        axios.post(LCMS_API_BASE_URL + "summative/generate", requestData, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(response => {
          if (response.status === 201) {
            const questionData = response.data;

            if(questionData?.data){
              
              setQuestionData(questionData?.data || []);
            }else{
              toast.error("Question Not generated! Please try again.", {
                autoClose: 3000, // 3 seconds
              });
              setQuestionData([]);
            }
            
          } else {
            toast.error("Question Not generated! Please try again.", {
              autoClose: 3000, // 3 seconds
            });
          }
        })
        .catch(error => {
          console.error("Error fetching options from API: ", error);
          if (
            (error?.response?.status === 403 || error?.response?.status === 401) &&
            (error?.response?.data?.errors?.[0]?.message === "invalid algorithm" || 
              error?.response?.data?.errors?.[0]?.message === "jwt expired" || 
              error?.response?.data?.errors?.[0]?.message === "invalid token" || 
              error?.response?.data?.errors?.[0]?.message === "Not Authorized")
          ) {
             // Server responded with a status other than 2xx
             const errorMessages = error?.response?.data?.errors
             ? error?.response?.data?.errors.map(err => err.message).join("\n")
             : "An error occurred. Please try again.";
             toast.error(`Error: ${errorMessages}`, {
               autoClose: 3000, // 3 seconds
               onClose: () => {
                localStorage.clear();
                navigate("/login");
              },
             });
          }else if (error.response) {
            // Server responded with a status other than 2xx
            const errorMessages = error?.response?.data?.errors
              ? error?.response?.data?.errors.map(err => err.message).join("\n")
              : "An error occurred. Please try again.";
              toast.error(`Error: ${errorMessages}`, {
                autoClose: 3000, // 3 seconds
              });
            //alert(`Error: ${errorMessages}`);
          } else if (error.request) {
            // Request was made but no response received
            toast.error(`No response from server. Please check your internet connection.`, {
              autoClose: 3000, // 3 seconds
            });
          } else {
            // Other errors toast.error("Activity details not found! Please try again.", {
              
            //alert("An error occurred while making the request.");
          }
          setLoader(false)
        })
      }else{
        navigate("/login")
      }
    } catch (error) {
      console.error("Error fetching data:", error)
    }
  }
  // useEffect( () => {
  //   if(existingData.length > 0){
      
  //     //console.log('looped')
  //   }
  // }, [existingData])
  useEffect( () => {
    if(questionData.length > 0){
      fetchpreviewSummativeData();
    }
  }, [questionData])
  //generated question based on Criteria end
  // preview for Summitive start
  const [showPrevPopup, setShowPrevPopup] = useState(false)
  const [popupPreviewSummativeData, setpopupPreviewSummativeData] = useState([])
  const [customActiveTab1, setcustomActiveTab1] = useState('0')
  const tog_large1 = () => {
    setcustomActiveTab1('0')
    setpopupPreviewSummativeData([])
    setShowPrevPopup(!showPrevPopup)
  }
  function toggleCustom1(tab) {
    if (customActiveTab1 !== tab) {
      setcustomActiveTab1(tab)
    }
  }


  function rearrangeEvenOddSecond(array) {
    const even = [] // To store even-indexed elements
    const odd = [] // To store odd-indexed elements

    array.forEach((element, index) => {
      if (index % 2 === 0) {
        even.push(element)
      } else {
        odd.push(element)
      }
    })

    // Combine odd and even arrays
    const rearranged = [...odd, ...even]

    return rearranged // Return the final rearranged array
  }

  function rearrangeEvenOdd(array) {
    array.sort((a, b) => {
      const textA = a.english_answer_text || a.answer_text || "";
      const textB = b.english_answer_text || b.answer_text || "";
      return textA.localeCompare(textB);
    });
    const even = [] // To store even-indexed elements
    const odd = [] // To store odd-indexed elements

    array.forEach((element, index) => {
      if (index % 2 === 0) {
        even.push(element)
      } else {
        odd.push(element)
      }
    })

    // Combine odd and even arrays
    const rearranged = [...odd, ...even]

    // Check if further rearrangement is needed
    if (rearranged.length > 1) {
      return rearrangeEvenOddSecond(rearranged) // Call recursively for further rearrangement
    }

    return rearranged // Return the final rearranged array
  }

  const goToNextTab = () => {
    const currentIndex = parseInt(customActiveTab1)
    if (subjectIdData === 1) {
      if (
        currentIndex <
        popupPreviewSummativeData.length - 1
      ) {
        toggleCustom1((currentIndex + 1).toString())
      }
    } else if (subjectIdData === 2) {
      if (
        currentIndex <
        popupPreviewSummativeData.length - 1
      ) {
        toggleCustom1((currentIndex + 1).toString())
      }
    }
  }
 
  const goToPrevTab = () => {
    const currentIndex = parseInt(customActiveTab1)
    if (currentIndex > 0) {
      toggleCustom1((currentIndex - 1).toString())
    }
  }
  const CountTotalCoinsForActivity = activityData => {
    let total_coins_stu = 0
  
  
    if (
      activityData &&  activityData.length > 0
    ) {
     
        activityData.forEach(lsquestion => {
            let questionData = lsquestion?.question_details || null;
            if (
              parseInt(lsquestion.subjectId) === 2 &&
              questionData
            ) {
                
              total_coins_stu += questionData?.question_parts?.length * 2 || 0
              
            } else if (
              parseInt(lsquestion.subjectId) === 1 &&
              questionData 
            ) {
              // lsquestion.english_question.forEach(lsquestionParts => {
                if (
                  parseInt(questionData?.english_question_category_id) ===
                    10 ||
                  parseInt(questionData?.english_question_category_id) === 13
                ) {
                  let total_part = questionData.question_parts
                  let array_part_data = total_part.filter(
                    part =>
                      part.question_answers.length > 0 &&
                      part.question_answers[0].english_answer_text &&
                      part.question_answers[0].english_answer_text != ""
                  )
                  total_coins_stu += array_part_data.length * 2 || 0
                } else {
                  total_coins_stu +=
                  questionData.question_parts.length * 2
                }
                // total_coins_stu += lsquestionParts.english_question_parts.length * 2;
              // })
            }
          })
       
    }
  
    return total_coins_stu;
  }


  const fetchpreviewSummativeData = async () => {
      //console.log(nodeId);
      if (getAuthToken() && getAuthToken() != "" && getAuthToken() != null) {
        try {
         
          axios.defaults.headers.common["Authorization"] = `Bearer ${getAuthToken()}`
          const responseListLibrary = await axios.post(
            BASE_URL + "activity/getPreviewSummitiveDetails",
            { 
              questionWithData: questionData
            }
          )
          const activitiesData = responseListLibrary.data.data
  
          //setSubjectIdData(subId)
  
          setpopupPreviewSummativeData(activitiesData)
  
          setShowPrevPopup(true)
  
      
        } catch (error) {
          console.error("Error in fetching List Library deatails:", error)
          //setLoader(false)
        }
      } else {
        navigate("/login")
      }
  }

  
  //replace functionality start
  const [ReplaceData, setReplaceData] = useState([])
  const fetchReplaceData = async() => {

    try {

      if (getAuthToken() && getAuthToken() != "" && getAuthToken() != null) {
        const template = {
          countryId: Number(countryId),
          subjectId: Number(subjectIdData),
          totalQuestionNeeded: Number(totalQuestion),
          // criteria: existingData.map(({ topicLabel, levelLabel, activityLabel, questionsNeededLabel, ...rest }) => rest)
          criteria: existingData.map(({ topicLabel, levelLabel, activityLabel, questionsNeededLabel, questionsNeeded, ...rest }) => {
            return {
              ...rest,
              ...(questionsNeeded !== 0 && { questionsNeeded }), // Only include if not 0
            };
          }),
          
        };
        
        const currentIndex = parseInt(customActiveTab1);
        axios.defaults.headers.common["Authorization"] = `Bearer ${getAuthToken()}`
        axios.post(LCMS_API_BASE_URL + "summative/replace", {
          template: template,
          questions: questionData,
          questionIndex: Number(currentIndex)
        }, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(response => {
          if (response.status === 201) {
            const questionData = response.data;

            if(questionData?.data){

              setQuestionData(questionData?.data || []);
              setReplaceData(questionData?.data || []);
            }else{
              setQuestionData([]);
              setReplaceData([]);
              setpopupPreviewSummativeData([]);
            }

            //fetchpreviewSummativeData();
            
          } else {
            toast.error("Question Not generated! Please try again.", {
              autoClose: 3000, // 3 seconds
            });
          }
        })
        .catch(error => {
          console.error("Error fetching options from API: ", error);
          if (
            (error?.response?.status === 403 || error?.response?.status === 401) &&
            (error?.response?.data?.errors?.[0]?.message === "invalid algorithm" || 
              error?.response?.data?.errors?.[0]?.message === "jwt expired" || 
              error?.response?.data?.errors?.[0]?.message === "invalid token" || 
              error?.response?.data?.errors?.[0]?.message === "Not Authorized")
          ) {
             // Server responded with a status other than 2xx
             const errorMessages = error?.response?.data?.errors
             ? error?.response?.data?.errors.map(err => err.message).join("\n")
             : "An error occurred. Please try again.";
             toast.error(`Error: ${errorMessages}`, {
               autoClose: 3000, // 3 seconds
               onClose: () => {
                localStorage.clear();
                navigate("/login");
              },
             });
          }else if (error.response) {
            // Server responded with a status other than 2xx
            const errorMessages = error?.response?.data?.errors
              ? error?.response?.data?.errors.map(err => err.message).join("\n")
              : "An error occurred. Please try again.";
              toast.error(`Error: ${errorMessages}`, {
                autoClose: 3000, // 3 seconds
              });
            //alert(`Error: ${errorMessages}`);
          } else if (error.request) {
            // Request was made but no response received
            toast.error(`No response from server. Please check your internet connection.`, {
              autoClose: 3000, // 3 seconds
            });
          } else {
            // Other errors toast.error("Activity details not found! Please try again.", {
              
            //alert("An error occurred while making the request.");
          }
          setLoader(false)
        })
      }else{
        navigate("/login")
      }
    } catch (error) {
      console.error("Error fetching data:", error)
    }
  }
  //replace functionality end

 
  useEffect( () => {
    if(ReplaceData.length > 0){
      fetchpreviewSummativeData();
    }
  }, [ReplaceData])
  

  //create summative add popup start
    //modal add
    const [modal_large, setmodal_large] = useState(false)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const tog_large = () => {
      setmodal_large(!modal_large)
    }
    const basicSchema = yup.object().shape({
      name: yup.string().required("Summative Actvitty Name is required."),  
    })
  
    const initialValues = {
      /*subjects*/
  
      centreKey: centKey,
      subjectId: subjectIdData,
      tutorKey: tutKey,
      name: "",
      description:""
    }
  
    const formik = useFormik({
      initialValues,
      validationSchema: basicSchema,
      enableReinitialize: true,
      //  onSubmit,
      onSubmit: async formValues => {
        // setIsSubmitting1(true);
  
        try {
          if (getAuthToken() && getAuthToken() != "" && getAuthToken() != null) {
            // setLoader(true);
            axios.defaults.headers.common["Authorization"] = `Bearer ${getAuthToken()}`
            const template = {
              countryId: Number(countryId),
              subjectId: Number(subjectIdData),
              totalQuestionNeeded: Number(totalQuestion),
              // criteria: existingData.map(({ topicLabel, levelLabel, activityLabel, questionsNeededLabel, ...rest }) => rest)
              criteria: existingData.map(({ topicLabel, levelLabel, activityLabel, questionsNeededLabel, questionsNeeded, ...rest }) => {
                return {
                  ...rest,
                  ...(questionsNeeded !== 0 && { questionsNeeded }), // Only include if not 0
                };
              }),
              
            };
            
              const response = await axios.post(
                LCMS_API_BASE_URL + "summative/create",
                {
                  ...formValues,
                  questions: questionData,
                  template: template,
                }
              )
  
              if (response && response.status === 201) {
                // Reset the form
                
                toast.success(" Your summative actvity was created", {
                  autoClose: 3000, // 3 seconds in this example
                })
                setmodal_large(false)
                formik.setFieldValue("name", "")
                formik.setFieldValue("description", "")
                formik.resetForm();
                navigate("/myLibrary")
  
                setIsSubmitting(false) // Re-enable the submit button
              } else {
                toast.error(
                  "Failure! Unable to create summative activity. Try again later",
                  {
                    autoClose: 3000, // 3 seconds in this example
                  }
                )
  
                setIsSubmitting(false) // Re-enable the submit button
              }
            
          }else{
            navigate("/login")
          }
        } catch (error) {
          console.error("Error fetching data:", error)

          if (
            (error?.response?.status === 403 || error?.response?.status === 401) &&
            (error?.response?.data?.errors?.[0]?.message === "invalid algorithm" || 
              error?.response?.data?.errors?.[0]?.message === "jwt expired" || 
              error?.response?.data?.errors?.[0]?.message === "invalid token" || 
              error?.response?.data?.errors?.[0]?.message === "Not Authorized")
          ) {
             // Server responded with a status other than 2xx
             const errorMessages = error?.response?.data?.errors
             ? error?.response?.data?.errors.map(err => err.message).join("\n")
             : "An error occurred. Please try again.";
             toast.error(`Error: ${errorMessages}`, {
               autoClose: 3000, // 3 seconds
               onClose: () => {
                localStorage.clear();
                navigate("/login");
              },
             });
          }else if (error.response) {
            // Server responded with a status other than 2xx
            const errorMessages = error?.response?.data?.errors
              ? error?.response?.data?.errors.map(err => err.message).join("\n")
              : "An error occurred. Please try again.";
              toast.error(`Error: ${errorMessages}`, {
                autoClose: 3000, // 3 seconds
              });
            //alert(`Error: ${errorMessages}`);
          } else if (error.request) {
            // Request was made but no response received
            toast.error(`No response from server. Please check your internet connection.`, {
              autoClose: 3000, // 3 seconds
            });
          } else {
            // Other errors toast.error("Activity details not found! Please try again.", {
              
            //alert("An error occurred while making the request.");
          }
         
  
          setIsSubmitting(false) // Re-enable the submit button
        } finally {
          setIsSubmitting(false) // Re-enable the submit button
        }
      },
    })
    // Now, you can set variables as needed:
    const values = formik.values
    const handleBlur = formik.handleBlur
    const touched = formik.touched
    const handleChange = formik.handleChange
    const errors = formik.errors
    const handleSubmit = formik.handleSubmit
    const setTouched = formik.setTouched
    const handleFileChange = formik.handleChange //check here surya broo
    const setValues = formik.setValues
    const handleReset = formik.handleReset


const getTotalQuestionCount = (data) => {
  return data.reduce((total, level) => {
    const levelQuestionCount = parseInt(level.questionCount) || 0;

    const topicTotal = level.topics?.reduce((topicSum, topic) => {
      const topicQuestionCount = parseInt(topic.questionCount) || 0;

      const activityTotal = topic.activities?.reduce((activitySum, activity) => {
        return activitySum + (parseInt(activity.questionCount) || 0);
      }, 0) || 0;

      return topicSum + topicQuestionCount + activityTotal;
    }, 0) || 0;

    return total + levelQuestionCount + topicTotal;
  }, 0);
};



  
  return (
    <React.Fragment>
      <ToastContainer />
      <Loader
        show={loader}
        type="body"
        // stack="vertical"
        // message="Loading Data"
      />
      <Container fluid className="pe-0">
        <div className="page-content fo-activity pe-0 ps-0">
          {adminMode ? (
            <div className="alert alert-info py-3 mb-3 mx-3">
              {adminViewName ? (
                <span>
                  Acting as <strong>{adminViewName}</strong>.{" "}
                  <Link to="/dashboard">Change tutor on Home</Link>
                </span>
              ) : (
                <span>
                  Select a tutor on <Link to="/dashboard">Home</Link> to create summative activities for them.
                </span>
              )}
            </div>
          ) : null}
          <div className="activity-wrapper d-flex">
            <div className="fo-left-full"  style={{ width: "100%"}}>
              
              <div className="page-title-box mb-3 mt-3">
                <div className="custom-pg_header justify-content-between mb-3">
                  <div className="" style={{ paddingTop: "18px" }}>
                    <div>
                      <h6
                        className="page-title mb-2"
                        style={{ lineHeight: "32px" }}
                      >
                        <Button
                          color="light"
                          className="bck-btn"
                          onClick={() => window.history.back()}
                        >
                          <i className="fas fa-chevron-left"></i>
                        </Button>{" "}
                        Create Summative Activity/Quiz
                       
                      </h6>
                      
                    </div>
                  </div>
                 
                </div>
              </div>
             

              <div
                className="act-filters d-flex align-items-center mt-4 mb-5"
                style={{ gap: "12px" }}
              >
                <div className="my-ss">
                  <Label className="font-size-15 fw-700 mb-1">
                    {" "}
                    Select Subject
                  </Label>

                  <Select
                    // {sessionStudentData && sessionStudentData != ""
                    // ? getUniqueSubjectId(sessionStudentData).join("& ") || "-"
                    // : "-"}
                    // {sessionStudentData && sessionStudentData != ""
                    //  ? 'value='{selectedGroupSubject ==  getUniqueSubjectId(sessionStudentData).join("&") ? 1  : "-"}

                    //                    : value={selectedGroupSubject}
                    //               }
                    value={
                      subjectOptions.find(
                        option => option.value == subjectIdData
                      )
                    }
                    // value={selectedGroupSubject}
                    // onChange={() => {
                    //   handleSelectGroup()

                    // }}
                    onChange={handleOnchangeGetSubject}
                    options={subjectOptions}
                    classNamePrefix="select2-selection"
                  />
                </div>
               
               
                <div className="my-ss">
                 <form
                    className="app-search page-search"
                    style={{ width: "350px", height: "30px" }}
                    onSubmit={(e) => e.preventDefault()} // Prevents form submission
                  >
                    <div className="position-relative">
                      <span className="fa fa-search"></span>
                      <input
                        type="text"
                        value={searchTerm}
                        className="form-control"
                        name="searchActivity"
                        id="searchActivity"
                        onChange={handleSearch}
                        
                        placeholder={
                          props.t("Search for topic or activity name") + "..."
                        }
                      />
                      
                    </div>
                  </form>
                </div>
              </div>
              <div className="act-filters d-flex align-items-center mt-4 mb-5" style={{ gap: "12px" }}>
                <div className="my-ss">
                  <Label className="font-size-15 fw-700 mb-1">Levels</Label>
                  <Select
                    // value={yearlevelOptions && yearlevelOptions[0].options.find(option => option.value === selectedGroupYearlevel)}
                    value={
                      yearlevelOptions.find(
                        option => option.value === yearlevelData
                      )
                    }
                    onChange={handleOnchangeGetYearlevel}
                    options={yearlevelOptions}
                    classNamePrefix="select2-selection"
                  />
                </div>   
                <div  className="my-ss">
                <Label className="font-size-15 fw-700 mb-1">Total Questions</Label>
                  <input
                    type="number"
                    placeholder="No. Of Questions"
                    className="form-control"
                    min="1" // Set minimum value
                    max="30" // Set maximum value
                    step="1" // Prevent decimal points
                    onKeyDown={(e) => {
                      if (e.key === "." || e.key === "," || e.key === "e") {
                        e.preventDefault(); // Prevent decimal points and exponent notation
                      }
                    }}
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
                    }}
                   
                    value={TotalQuestionValue}
                    onChange={(e) => {
                      setTotalQuestionValue(Number(e.target.value) || ''); // Just update value without validation
                    }}
                    onBlur={(e) => {
                      const value = Number(e.target.value); // Ensure it's a number
                     
                      // Usage
                        const totalQuestionNeeded = getTotalQuestionCount(activityLevelData);
                    
                        if (value >= totalQuestionNeeded && value <= 30) {
                          setTotalQuestionValue(value);
                        } else if (value < totalQuestionNeeded) {
                          toast.error(`Sorry, the selected total question is ${totalQuestionNeeded}.`, {
                            autoClose: 3000, // 3 seconds
                          });
                          setTotalQuestionValue(totalQuestionNeeded);
                        } else {
                          toast.error(`Sorry, the maximum number of questions reached.`, {
                            autoClose: 3000, // 3 seconds
                          });
                          setTotalQuestionValue(30);
                        }
                    }}
                    
                  />
                </div>
                
                
              </div>
              <Container
                className="activity-scroll mt-5"
              >
                
                <div>
               
                  <div className="">
                    {activityLevelData &&
                    activityLevelData.length > 0 ? (
                      // Render if activities array is not empty
                      activityLevelData.filter(activity => activity.topics && activity.topics.length > 0)
                      .filter(level => yearlevelData == 0 || (level.levelId && level.levelId == parseInt(yearlevelData))) // Skip filtering if yearlevelData is 0
                      .map((activity, index) => (
                        <div
                          className="accordion"
                          id={`accordion${index}`}
                          key={index}
                        >
                          <div className="accordion-item">
                            <div
                              className="d-flex gap-2 w-100 custom-accordion-header align-items-center"
                              style={{ cursor: "pointer" }}
                              onClick={() => toggleAccordion(index, activity)}
                              tabIndex={0}
                              role="button"
                              onKeyDown={e => { if (e.key === "Enter" || e.key === " ") toggleAccordion(index, activity) }}
                            >
                              <h2
                                className="accordion-header font-size-14 fw-semibold w-100"
                                
                                id={`heading${index}`}
                              >
                              {activity.levelName}
                              </h2>
                              <span
                                className={`accordion-button bg-white fw-semibold ${activeIndex === index ? "" : "collapsed"}`}
                                style={{ pointerEvents: "none" }}
                                aria-hidden="true"
                              />
                            </div>
                            <Collapse
                              isOpen={activeIndex === index}
                              className="accordion-collapse"
                              aria-labelledby={`heading${index}`}
                              data-bs-parent={`#accordion${index}`}
                            >
                              <div className="accordion-body p-0">
                               
                                {activity.topics &&
                                activity.topics.length > 0  ? (
                                  //search filter start Flow check activity found or not after applay to search filter
                                  activity.topics.filter(topic => topic.activities && topic.activities.length > 0).filter(
                                    topic =>
                                      (topic.topicName &&
                                        topic.topicName
                                          .toLowerCase()
                                          .includes(searchTerm)) || // Match topic_name
                                      topic.activities.some(
                                        activitys =>
                                          activitys.activityName &&
                                          activitys.activityName
                                            .toLowerCase()
                                            .includes(searchTerm) // Match node_name
                                      )
                                  ).length === 0 ? (
                                    <p className="text-center p-2 text-dark fw-500">
                                      No activities or topic found for this year
                                      level.
                                    </p>
                                  ) : (
                                    activity.topics.filter(topic => topic.activities && topic.activities.length > 0)
                                    .filter(
                                      topic =>
                                        (topic.topicName &&
                                          topic.topicName
                                            .toLowerCase()
                                            .includes(searchTerm)) || // Match topic_name
                                        topic.activities.some(
                                          activitys =>
                                            activitys.activityName &&
                                            activitys.activityName
                                              .toLowerCase()
                                              .includes(searchTerm) // Match node_name
                                        )
                                    ).map((topic, topicIndex) => (
                                      <div
                                        className="accordion"
                                        id={`accordionInner${topicIndex}`}
                                        key={topicIndex}
                                      >
                                        <div className="accordion-item">
                                          <div
                                            className="d-flex gap-2 w-100 custom-accordion-header align-items-center"
                                            style={{ cursor: "pointer" }}
                                            onClick={e => {
                                              // Prevent toggle if clicking on input or checkbox
                                              if (
                                                e.target.tagName === "INPUT" ||
                                                e.target.closest("input")
                                              ) return;
                                              toggleAccordion1(topicIndex);
                                            }}
                                            tabIndex={0}
                                            role="button"
                                            onKeyDown={e => { if (e.key === "Enter" || e.key === " ") toggleAccordion1(topicIndex); }}
                                          >
                                              <input
                                                type="checkbox"
                                                checked={topic.selected}
                                                onChange={(e) =>
                                                  setActivityLevelData((prev) =>
                                                    prev.map((l) =>
                                                      l.levelId === activity.levelId
                                                        ? {
                                                            ...l,
                                                            topics: l.topics.map((t) =>
                                                              t.topicId === topic.topicId ? { ...t, selected: e.target.checked } : t
                                                            ),
                                                          }
                                                        : l
                                                    )
                                                  )
                                                }
                                              onClick={e => e.stopPropagation()} // Prevent accordion toggle
                                              />
                                              <h2
                                                className="accordion-header font-size-14 fw-semibold w-70 p-2"
                                                style={{ lineHeight: "2rem" }}
                                                id={`headingInner${topicIndex}`}
                                              >
                                              {highlightText(topic.topicName, searchTerm)}
                                              </h2>
                                              <input
                                                type="number"
                                                className="form-control w-30"
                                                  placeholder="No. Of Questions"
                                                  min="1" // Set minimum value
                                                  max="30" // Set maximum value
                                                  step="1" // Prevent decimal points
                                                  onKeyDown={(e) => {
                                                    if (e.key === "." || e.key === "," || e.key === "e") {
                                                      e.preventDefault(); // Prevent decimal points and exponent notation
                                                    }
                                                  }}
                                                  onInput={(e) => {
                                                    e.target.value = e.target.value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
                                                  }}
                                                value={topic.questionCount}
                                                onChange={(e) => {
                                                    const value = Number(e.target.value); // Ensure it's a number

                                                    // Usage
                                                      const totalQuestionNeeded = getTotalQuestionCount(activityLevelData) - topic.questionCount;

                                                  if((TotalQuestionValue <= 0 || !TotalQuestionValue) || (totalQuestionNeeded + value) <= TotalQuestionValue){
                                                    if (value <= 30) {
                                                      setActivityLevelData((prev) =>
                                                        prev.map((l) =>
                                                          l.levelId === activity.levelId
                                                            ? {
                                                                ...l,
                                                                topics: l.topics.map((t) =>
                                                                  t.topicId === topic.topicId ? { ...t, questionCount: value || null} : t
                                                                ),
                                                              }
                                                            : l
                                                        )
                                                      )
                                                    } else {
                                                      toast.error(`Sorry, the maximum number of questions allowed is 30.`, {
                                                        autoClose: 3000, // 3 seconds
                                                      });

                                                      setActivityLevelData((prev) =>
                                                        prev.map((l) =>
                                                          l.levelId === activity.levelId
                                                            ? {
                                                                ...l,
                                                                topics: l.topics.map((t) =>
                                                                  t.topicId === topic.topicId ? { ...t, questionCount: 30 } : t
                                                                ),
                                                              }
                                                            : l
                                                        )
                                                      )
                                                    }
                                                  }else{
                                                    toast.error(`Sorry, the Total questions reached.`, {
                                                      autoClose: 3000, // 3 seconds
                                                    });
                                                    setActivityLevelData((prev) =>
                                                      prev.map((l) =>
                                                        l.levelId === activity.levelId
                                                          ? {
                                                              ...l,
                                                              topics: l.topics.map((t) =>
                                                                t.topicId === topic.topicId ? { ...t, questionCount: '' } : t
                                                              ),
                                                            }
                                                          : l
                                                      )
                                                    )
                                                  }
                                                }
                                              }

                                              />
                                            <span
                                              className={`accordion-button bg-white font-size-14 fw-semibold w-30 ${activeIndex1 === topicIndex ? "" : "collapsed"}`}
                                              style={{ pointerEvents: "none" }}
                                              aria-hidden="true"
                                            />
                                          </div>


                                          {topic.activities &&
                                          topic.activities.length > 0 ? (
                                            topic.activities.map(
                                              (topicTitle, topicTitleIndex) => (
                                                <Collapse
                                                  isOpen={
                                                    activeIndex1 === topicIndex
                                                  } // Use col2 state here
                                                  className="accordion-collapse"
                                                  key={topicTitleIndex}
                                                >
                                                  <div className="accordion-body p-0">
                                                    <div className="table-responsive">
                                                      <Table className="table mb-0">
                                                        <tbody>
                                                          <tr>
                                                            <th
                                                              scope="row"
                                                              width="70%"
                                                            >
                                                               
                                                               <input
                                                                type="checkbox"
                                                                className="me-2"
                                                                checked={topicTitle.selected}
                                                                onChange={(e) =>
                                                                  setActivityLevelData((prev) =>
                                                                    prev.map((l) =>
                                                                      l.levelId === activity.levelId
                                                                        ? {
                                                                            ...l,
                                                                            topics: l.topics.map((t) =>
                                                                              t.topicId === topic.topicId
                                                                                ? {
                                                                                    ...t,
                                                                                    activities: t.activities.map((a) =>
                                                                                      a.activityId === topicTitle.activityId
                                                                                        ? { ...a, selected: e.target.checked }
                                                                                        : a
                                                                                    ),
                                                                                  }
                                                                                : t
                                                                            ),
                                                                          }
                                                                        : l
                                                                    )
                                                                  )
                                                                }
                                                              />
                                                              {highlightText(
                                                                topicTitle.activityName,
                                                                searchTerm
                                                              )}

                                                              
                                                            
                                                            </th>
                                                            <th  
                                                            
                                                              scope="row"
                                                              width="30%">
                                                            <input
                                                                type="number"
                                                                className="form-control w-80"
                                                                  placeholder="No. Of Questions"
                                                                  min="1" // Set minimum value
                                                                  max="30" // Set maximum value
                                                                  step="1" // Prevent decimal points
                                                                  onKeyDown={(e) => {
                                                                    if (e.key === "." || e.key === "," || e.key === "e") {
                                                                      e.preventDefault(); // Prevent decimal points and exponent notation
                                                                    }
                                                                  }}
                                                                  onInput={(e) => {
                                                                    e.target.value = e.target.value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
                                                                  }}
                                                                value={topicTitle.questionCount}
                                                                onChange={(e) => {
                                                                  const value = Number(e.target.value); // Ensure it's a number
                                                                 // Usage
                                                                    const totalQuestionNeeded = getTotalQuestionCount(activityLevelData) - topicTitle.questionCount;
                                                                    
                                                                if((TotalQuestionValue <= 0 || !TotalQuestionValue) || (totalQuestionNeeded + value) <= TotalQuestionValue){
                                                                  if (value <= 30) {
                                                                    setActivityLevelData((prev) =>
                                                                      prev.map((l) =>
                                                                        l.levelId === activity.levelId
                                                                          ? {
                                                                              ...l,
                                                                              topics: l.topics.map((t) =>
                                                                                t.topicId === topic.topicId ? {
                                                                                  ...t,
                                                                                  activities: t.activities.map((a) =>
                                                                                    a.activityId === topicTitle.activityId
                                                                                      ? { ...a, questionCount: value || null }
                                                                                      : a
                                                                                  ),
                                                                                }
                                                                                : t
                                                                              ),
                                                                            }
                                                                          : l
                                                                      )
                                                                    )
                                                                  } else {
                                                                    toast.error(`Sorry, the maximum number of questions allowed is 30.`, {
                                                                      autoClose: 3000, // 3 seconds
                                                                    });
                                                                
                                                                    setActivityLevelData((prev) =>
                                                                      prev.map((l) =>
                                                                        l.levelId === activity.levelId
                                                                          ? {
                                                                              ...l,
                                                                              topics: l.topics.map((t) =>
                                                                                t.topicId === topic.topicId ? {
                                                                                  ...t,
                                                                                  activities: t.activities.map((a) =>
                                                                                    a.activityId === topicTitle.activityId
                                                                                      ? { ...a, questionCount: 30 || null }
                                                                                      : a
                                                                                  ),
                                                                                }
                                                                                : t
                                                                              ),
                                                                            }
                                                                          : l
                                                                      )
                                                                    )
                                                                  }
                                                                }else{
                                                                  toast.error(`Sorry, the Total questions reached.`, {
                                                                    autoClose: 3000, // 3 seconds
                                                                  });
                                                                  setActivityLevelData((prev) =>
                                                                    prev.map((l) =>
                                                                      l.levelId === activity.levelId
                                                                        ? {
                                                                            ...l,
                                                                            topics: l.topics.map((t) =>
                                                                              t.topicId === topic.topicId ? {
                                                                                ...t,
                                                                                activities: t.activities.map((a) =>
                                                                                  a.activityId === topicTitle.activityId
                                                                                    ? { ...a, questionCount: '' }
                                                                                    : a
                                                                                ),
                                                                              }
                                                                              : t
                                                                            ),
                                                                          }
                                                                        : l
                                                                    )
                                                                  )
                                                                }
                                                              }}
                                                              
                                                              />
                                                            </th>
                                                           
                                                          </tr>
                                                        </tbody>
                                                      </Table>
                                                    </div>
                                                  </div>
                                                </Collapse>
                                              )
                                            )
                                          ) : (
                                            // Render if TopicActivities array is empty
                                            <p className="text-center p-2 text-dark fw-500">
                                              No activities found for this topic
                                            </p>
                                          )}
                                        </div>
                                      </div>
                                    ))
                                  )
                                ) : !InnerLoder ? (
                                  <p className="text-center p-2 text-dark fw-500">
                                    No topics found for this activity
                                  </p>
                                ) : null}
                              </div>
                            </Collapse>
                          </div>
                        </div>
                      ))
                    ) : (
                      // Render if activities array is empty
                      <p className="text-center p-2 text-dark fw-500">
                        No activities found
                      </p>
                    )}
                             
                     
                  </div>
                </div>
              </Container>
            </div>

          <div className="fo-right">
              <Card className="border-top">
                <CardBody
                  className=""
                  style={{ padding: "12px", paddingTop: "0" }}
                >
                  <h6
                    className="mb-12 font-size-16 fw-500 text-dark"
                    style={{ paddingTop: "36px" }}
                  >
                    Selected Topic/Activities{" "}
                    <span>
                      (
                      {Array.isArray(existingData) && existingData.length > 0
                        ? existingData.length
                        : 0}
                      )
                    </span>{" "}
                  </h6>
                  <h6
                    className="mb-12 font-size-16 fw-500 text-dark"
                    style={{ paddingTop: "5px" }}
                  >
                    Total Questions{" "}
                    <span>
                      (
                      {totalQuestion
                        ? totalQuestion
                        : 0}
                      )
                    </span>{" "}
                  </h6>

                  <div className="activities-cts overflow-auto">
                    
                    {Array.isArray(existingData) && existingData.length > 0
                      ? existingData.map(activitydata => {
                          return (
                            <div
                              className="bg-supermild position-relative mb-1"
                              style={{ padding: "9px" }}
                            >
                              
                              <h6 className="two_line-ellipse font-size-15 fw-700 text-dark w-90">
                                {[
                                  activitydata.levelLabel && activitydata.levelLabel.trim(),
                                  activitydata.topicLabel && activitydata.topicLabel.trim(),
                                  activitydata.activityLabel && activitydata.activityLabel.trim()
                                ]
                                  .filter(Boolean) // Remove null, undefined, or empty strings
                                  .join(" - ")} {/* Join elements with " - " but avoid trailing dash */}
                              </h6>

                              <div className="act-info mt-3">
                                <ul className="list-unstyled mb-0 align-items-center gap-2">
                                  <li className="font-size-15">
                                    Type : {activitydata.type}
                                  </li>
                                  {/* <span className="circle"></span> */}
                                  <br></br>
                                  <li className="font-size-15">
                                    Questions : {activitydata.questionsNeededLabel}
                                  </li>
                                 
                                </ul>
                                
                              </div>
                            </div>
                          )
                        })
                      : ""}
                  </div>
                  <div className="btn-group w-100 flex-column py-4">
                   

                    <Button
                      className="w-100 btn-lg cst-danger"
                      color="danger"
                       onClick={() =>{
                        if(Array.isArray(existingData) && existingData.length > 0){
                          fetchgenerateData();
                        }else{
                          toast.error("Question Not generated! Please try again.", {
                            autoClose: 3000, // 3 seconds
                          });
                        }
                       
                       
                       }}
                    >
                      Generate
                      
                    </Button>
                  </div>
                </CardBody>
              </Card>
            </div> 
          </div>
        </div>
        <div>
          {/* create summative activity popup */}
          <Modal isOpen={modal_large} toggle={tog_large} size="lg">
            <ModalHeader className="mt-0" toggle={tog_large}>
              Add Summative Activity
            </ModalHeader>
            <ModalBody>
              <Form
                autoComplete="off"
                onSubmit={handleSubmit}
                ref={formRef}
              >
                <Row className="mb-3 g-3">
                 

                  <Col className="col-6">
                    <div className="">
                      <label
                        htmlFor="example-text-input"
                        className="col-form-label"
                      >
                        Summative Activity Name<span style={{ color: 'red' }}>*</span>
                      </label>
                      <div className="">
                        <Input
                          type="text"
                          value={values.name}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          id="name"
                          className={
                            errors.name && touched.name
                              ? "form-control input-error"
                              : ""
                          }
                        />
                        {errors.name && touched.name && (
                          <p className="error">{errors.name}</p>
                        )}
                      </div>
                    </div>
                  </Col>
                  <Col className="col-12">
                    <div className="">
                      <label
                        htmlFor="example-text-input"
                        className="col-form-label"
                      >
                        Description
                      </label>
                      <div className="">
                        <textarea
                          id={`description`}
                          
                          placeholder=""
                          value={values.description}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          rows="4"
                          className={
                            errors.description && touched.description
                              ? "form-control input-error"
                              : "form-control"
                          }
                        />
                        
                        {errors.description && touched.description && (
                          <p className="error">{errors.description}</p>
                        )}
                      </div>
                    </div>
                  </Col>
                  
                </Row>
                <div className="text-end mt-4">
                  {/* <Button type="submit" color="danger">
                    Add
                  </Button> */}
                  <Button
                    type="submit"
                    variant="contained"
                    color="danger"
                    disabled={isSubmitting}
                  >
                    Add
                  </Button>
                </div>
              </Form>
            </ModalBody>
          </Modal>
          <Modal
            isOpen={showPrevPopup}
            toggle={tog_large1}
            size="xl"
            className="remove-bd"
          >
            <MathJax inline dynamic>
              {Object.keys(popupPreviewSummativeData).length > 0 ? (
                <>
                  <ModalHeader
                    className="mt-0 preview-activity"
                    toggle={tog_large1}
                    style={{ backgroundColor: "#20365b" }}
                  >
                    <div className="d-flex align-items-center justify-content-between w-90">
                      <h6 className="mb-0 font-size-20 text-white w-60 fw-500">
                      Summative - Preview
                      </h6>
                      <div className="d-flex align-items-center gap-4">
                       {/* <p className="mb-0 text-uppercase luminous-wht">
                          {" "}
                          <span className="text-yellow me-1">
                            {sessionStudentData && sessionStudentData != ""
                              ? getUniqueSubjectNames(sessionStudentData).join(
                                  " & "
                                ) || "-"
                              : "-"}
                          </span><br></br>{" "}
                        </p> */}
                        <div className="luminous-wht font-size-16">
                          <img width={24} className="" src={awicon} alt="" /> 0 /{" "}
                          {popupPreviewSummativeData &&
                          popupPreviewSummativeData.length > 0 ? CountTotalCoinsForActivity(popupPreviewSummativeData) : 0}{" "}
                          coins earned
                        </div>
                      </div>
                    </div>
                  </ModalHeader>
                  <ModalBody>
                    {subjectIdData === 1 && (
                      <Container className="custom-wt">
                        <div className="assessement-section assessment-width-hold">
                          <Nav tabs className="md-prev-tab mb-3">
                            {
                              // popupPreviewSummativeData && (subjectIdData === 1
                              //   ? popupPreviewSummativeData.english_question_activities
                              //   : subjectIdData === 2
                              //     ? popupPreviewSummativeData.question_activities
                              //     : []
                              // ).map((activity, popactivityindex) => (
                              popupPreviewSummativeData &&
                                popupPreviewSummativeData.length > 0 &&
                                popupPreviewSummativeData.map(
                                  (activity, popactivityindex) => (
                                    <NavItem key={popactivityindex}>
                                      <NavLink
                                        style={{ cursor: "pointer", border: "unset" }}
                                        className={
                                          classnames({
                                            active:
                                              customActiveTab1 ===
                                              popactivityindex.toString(),
                                          }) + " display-number"
                                        }
                                        onClick={() =>
                                          toggleCustom1(
                                            popactivityindex.toString()
                                          )
                                        }
                                      >
                                        <span className="font-size-20 fw-800">
                                          {popactivityindex + 1}
                                        </span>
                                      </NavLink>
                                    </NavItem>
                                  )
                                )
                            }
                          </Nav>

                          <TabContent
                            activeTab={customActiveTab1}
                            className="text-muted question_container"
                          >
                            {popupPreviewSummativeData &&
                              popupPreviewSummativeData.length > 0 &&
                              popupPreviewSummativeData.map(
                                (activity, popactivityindex) => (
                                  <TabPane
                                    tabId={popactivityindex.toString()}
                                    key={popactivityindex}
                                  >
                                    {" "}
                                    <div className="hw-list mt-4 pb-100">
                                      <div className={
                                          [8, 2, 12].includes(
                                            activity.question_details?.english_question_new_category?.english_question_category_id
                                          ) ? "question-container-custom"
                                            : ""
                                        }>
                                        <div className={
                                              [8, 2, 12].includes(
                                                activity.question_details?.english_question_new_category?.english_question_category_id
                                              )  ? "QuestionBody jss13 passage-area flex-fill border"
                                                : "QuestionBody jss13 mb-3"
                                            }>
                                          <div>
                                            <div
                                              className="mt-3"
                                              dangerouslySetInnerHTML={{
                                                __html:
                                                  activity.question_details &&
                                                  activity.question_details
                                                    .english_question_instruction
                                                    ? activity.question_details &&
                                                      activity.question_details.english_question_instruction
                                                        .replace(
                                                          /\[(\d+)Answer char=\d+\]/g,
                                                          ""
                                                        )
                                                        .replace(
                                                          /\[Answer char=\d+\]/g,
                                                          ""
                                                        )
                                                    : null,
                                              }}
                                            ></div>

                                            {activity.question_details &&
                                            activity.question_details
                                              .english_question_choices &&
                                            activity.question_details
                                              .english_question_choices.length >
                                              0 ? (
                                              <div className="mt-3 my-2 border border-dark choice-options_wrapper">
                                                {activity.question_details.english_question_choices.map(
                                                  (qusChoice, Cindex) => (
                                                    <div
                                                      class="choice-options_child"
                                                      key={Cindex}
                                                    >
                                                      <div>
                                                        {qusChoice.choice_no}
                                                      </div>
                                                      <div>
                                                        {qusChoice.choice_text}
                                                      </div>
                                                    </div>
                                                  )
                                                )}
                                              </div>
                                            ) : null}

                                            {activity.question_details &&
                                              activity.question_details
                                                .english_question_new_category &&
                                              activity.question_details
                                                .english_question_new_category
                                                .english_question_category_id ===
                                                1 &&
                                              (activity.question_details
                                                .english_question_text ? (
                                                <div
                                                  className="mt-3"
                                                  dangerouslySetInnerHTML={{
                                                    __html:
                                                      activity.question_details.english_question_text
                                                        .replace(
                                                          /\[(\d+)Answer char=\d+\]/g,
                                                          ""
                                                        )
                                                        .replace(
                                                          /\[Answer char=\d+\]/g,
                                                          ""
                                                        ),
                                                  }}
                                                />
                                              ) : null)}
                                            {activity.question_details &&
                                              activity.question_details
                                                .english_question_new_category &&
                                              activity.question_details
                                                .english_question_new_category
                                                .english_question_category_id ===
                                                2 &&
                                              (activity.question_details
                                                .english_question_text ? (
                                                <div
                                                  className="mt-3"
                                                  dangerouslySetInnerHTML={{
                                                    __html:
                                                      activity.question_details.english_question_text
                                                        .replace(
                                                          /\[(\d+)Answer char=\d+\]/g,
                                                          ""
                                                        )
                                                        .replace(
                                                          /\[Answer char=\d+\]/g,
                                                          ""
                                                        ),
                                                  }}
                                                />
                                              ) : null)}
                                            {activity.question_details &&
                                              activity.question_details
                                                .english_question_new_category &&
                                              activity.question_details
                                                .english_question_new_category
                                                .english_question_category_id ===
                                                8 &&
                                              (activity.question_details
                                                .english_question_text ? (
                                                <div
                                                  className="mt-4"
                                                  dangerouslySetInnerHTML={{
                                                    __html: activity
                                                      .question_details
                                                      .english_question_text
                                                      ? activity.question_details.english_question_text
                                                          .replace(
                                                            /\[(\d+)Answer char=\d+\]/g,
                                                            ""
                                                          )
                                                          .replace(
                                                            /\[Answer char=\d+\]/g,
                                                            ""
                                                          )
                                                          .replace(/&nbsp;/g, "")
                                                          .split("</p>")
                                                          .map(
                                                            (paragraph, index) =>
                                                              paragraph
                                                                ? `<div class="d-flex mt-2"><p class="me-2">${
                                                                    index + 1
                                                                  } ${paragraph}</p></div>`
                                                                : ""
                                                          )
                                                          .filter(Boolean)
                                                          .join("")
                                                      : null,
                                                  }}
                                                />
                                              ) : //  <div className="mt-3" dangerouslySetInnerHTML={{ __html: activity.english_question.english_question_text.replace(/\[(\d+)Answer char=\d+\]/g, '').replace(/\[Answer char=\d+\]/g, '') }} />
                                              null)}
                                            {activity.question_details &&
                                              activity.question_details
                                                .english_question_new_category &&
                                              (parseInt(
                                                activity.question_details
                                                  .english_question_new_category
                                                  .english_question_category_id
                                              ) === 10 ||
                                                parseInt(
                                                  activity.question_details
                                                    .english_question_new_category
                                                    .english_question_category_id
                                                ) === 13) &&
                                              (activity.question_details
                                                .english_question_text ? (
                                                <div
                                                  className="mt-3"
                                                  dangerouslySetInnerHTML={{
                                                    __html:
                                                      activity.question_details.english_question_text
                                                        .replace(
                                                          /\[(\d+)Answer char=\d+\]/g,
                                                          ""
                                                        )
                                                        .replace(
                                                          /\[Answer char=\d+\]/g,
                                                          ""
                                                        ),
                                                  }}
                                                />
                                              ) : null)}
                                            {activity.question_details &&
                                              activity.question_details
                                                .english_question_new_category &&
                                              (parseInt(
                                                activity.question_details
                                                  .english_question_new_category
                                                  .english_question_category_id
                                              ) === 10 ||
                                                parseInt(
                                                  activity.question_details
                                                    .english_question_new_category
                                                    .english_question_category_id
                                                ) === 13) &&
                                              (activity.question_details
                                                .part_heading ? (
                                                <div
                                                  className="mt-3"
                                                  dangerouslySetInnerHTML={{
                                                    __html:
                                                      activity.question_details.part_heading
                                                        .replace(
                                                          /\[(\d+)Answer char=\d+\]/g,
                                                          ""
                                                        )
                                                        .replace(
                                                          /\[Answer char=\d+\]/g,
                                                          ""
                                                        ),
                                                  }}
                                                />
                                              ) : null)}
                                          </div>
                                        </div>
                                        <div className={
                                            [8, 2, 12].includes(
                                              activity.question_details?.english_question_new_category?.english_question_category_id
                                            )  ? "question-area flex-fill border"
                                              : ""
                                          }>
                                        {activity &&
                                          activity.question_details &&
                                          activity.question_details
                                            .question_parts &&
                                          activity.question_details
                                            .question_parts &&
                                          activity.question_details.question_parts.map(
                                            (
                                              activityQuestion,
                                              indexactivityQuestion
                                            ) => (
                                              <>

                                              

                                                {activity.question_details &&
                                                  activity.question_details
                                                    .english_question_new_category &&
                                                  activity.question_details
                                                    .english_question_new_category
                                                    .english_question_category_id ==
                                                    1 && (
                                                    <ul className="dg-selector list-unstyled mb-0 pt-4">
                                                      {parseInt(activityQuestion.english_question_part_automark) === 0? <div className="d-flex justify-content-end mb-2"><div className="badge bg-primary text-white font-size-12 mb-0" style={{color: 'white'}}>Manual Marking</div></div> : null}
                                                      {activityQuestion &&
                                                        activityQuestion.question_answers &&
                                                        (() => {
                                                          let serialNumber = 0 // Initialize a separate counter for serial numbers
                                                          return rearrangeEvenOdd(
                                                            activityQuestion.question_answers
                                                          ).map(
                                                            (
                                                              activityQuestionAns,
                                                              indexQuestionAns
                                                            ) => {
                                                              if (
                                                                activityQuestionAns &&
                                                                activityQuestionAns.english_answer_text
                                                              ) {

                                                                const cleanText = activityQuestionAns.english_answer_text
                                                                .replace(/&nbsp;/g, '')
                                                                .replace(/`/g, '')
                                                                .replace(/<[^>]*>/g, '')
                                                                .trim();
              
                                                                  const hasImage = /<img\s+[^>]*>/gi.test(activityQuestionAns.english_answer_text);
                    
                                                                  if (!cleanText && !hasImage) {
                                                                      return null; // Skip rendering if english_answer_text is effectively empty and no image is present
                                                                  }
                                                                serialNumber++ // Increment serial number only when there's valid text

                                                                return (
                                                                  <li
                                                                    key={
                                                                      indexQuestionAns
                                                                    }
                                                                    className={
                                                                      activityQuestionAns.english_answer_is_correct ==
                                                                      1
                                                                        ? "selector-display"
                                                                        : ""
                                                                    }
                                                                  >
                                                                    <div className="p-2 px-3 font-size-18">
                                                                      {
                                                                        serialNumber
                                                                      }
                                                                    </div>
                                                                    <div className="p-2 px-3 dg-media border-start-display">
                                                                      <div
                                                                        dangerouslySetInnerHTML={{
                                                                          __html:
                                                                            activityQuestionAns.english_answer_text,
                                                                        }}
                                                                      />
                                                                    </div>
                                                                  </li>
                                                                )
                                                              }

                                                              return null // Skip rendering if there's no answer text
                                                            }
                                                          )
                                                        })()}
                                                    </ul>
                                                  )}

                                              
                                                {activity.question_details &&
                                                  activity.question_details
                                                    .english_question_new_category &&
                                                  activity.question_details
                                                    .english_question_new_category
                                                    .english_question_category_id ==
                                                    2 && (
                                                    <>
                                                      <div className="mr-3">
                                                        {indexactivityQuestion +
                                                          1}
                                                        {")"}
                                                      </div>
                                                      <ul className="dg-selector list-unstyled mb-0 pt-2">
                                                        {parseInt(activityQuestion.english_question_part_automark) === 0? <div className="d-flex justify-content-end mb-2"><div className="badge bg-primary text-white font-size-12 mb-0" style={{color: 'white'}}>Manual Marking</div></div> : null}
                                                        {activityQuestion &&
                                                          activityQuestion.question_answers &&
                                                          (() => {
                                                            let serialNumber = 0 // Separate counter for serial number
                                                            const answers = activityQuestion.english_question_part_answer_type === 4
                                                                              ? rearrangeEvenOdd(activityQuestion.question_answers)
                                                                              : activityQuestion.question_answers || [];
                                                                              
                                                            return answers.map(
                                                              (
                                                                activityQuestionAns2,
                                                                indexQuestionAns2
                                                              ) => {
                                                                if (
                                                                  activityQuestionAns2 &&
                                                                  activityQuestionAns2.english_answer_text
                                                                ) {

                                                                  const cleanText = activityQuestionAns2.english_answer_text
                                                                  .replace(/&nbsp;/g, '')
                                                                  .replace(/`/g, '')
                                                                  .replace(/<[^>]*>/g, '')
                                                                  .trim();
                
                                                                    const hasImage = /<img\s+[^>]*>/gi.test(activityQuestionAns2.english_answer_text);
                      
                                                                    if (!cleanText && !hasImage) {
                                                                        return null; // Skip rendering if english_answer_text is effectively empty and no image is present
                                                                    }
                                                                  serialNumber++ // Increment serial number only if there's a valid answer text

                                                                  return (
                                                                    <li
                                                                      key={
                                                                        indexQuestionAns2
                                                                      }
                                                                      className={
                                                                        ""
                                                                      }
                                                                    >
                                                                      {activityQuestion.english_question_part_answer_type === 4 ? 
                                                                      <div className="p-2 px-3 font-size-18">
                                                                        {
                                                                          serialNumber
                                                                        }
                                                                      </div> : null}
                                                                      <div className="p-2 px-3 dg-media border-start-display">
                                                                        <div
                                                                          dangerouslySetInnerHTML={{
                                                                            __html:
                                                                              activityQuestionAns2.english_answer_text,
                                                                          }}
                                                                        />
                                                                      </div>
                                                                    </li>
                                                                  )
                                                                }

                                                                return null // Skip rendering if answer text is null
                                                              }
                                                            )
                                                          })()}
                                                      </ul>
                                                    </>
                                                  )}

                                              
                                                {activity.question_details &&
                                                  activity.question_details
                                                    .english_question_new_category &&
                                                  activity.question_details
                                                    .english_question_new_category
                                                    .english_question_category_id ==
                                                    8 && (
                                                    <>
                                                      <div className="p-2 px-3 font-size-18">
                                                        {activityQuestion &&
                                                        activityQuestion.english_question_part_text ? (
                                                          <div
                                                            dangerouslySetInnerHTML={{
                                                              __html: `${
                                                                indexactivityQuestion +
                                                                1
                                                              }) ${activityQuestion.english_question_part_text
                                                                .replace(
                                                                  /\[(\d+)Answer char=\d+\]/g,
                                                                  ""
                                                                )
                                                                .replace(
                                                                  /\[Answer char=\d+\]/g,
                                                                  ""
                                                                )}`,
                                                            }}
                                                          />
                                                        ) : (
                                                          ""
                                                        )}
                                                      </div>

                                                      <ul className="dg-selector list-unstyled mb-0 pt-4">
                                                      {parseInt(activityQuestion.english_question_part_automark) === 0? <div className="d-flex justify-content-end mb-2"><div className="badge bg-primary text-white font-size-12 mb-0" style={{color: 'white'}}>Manual Marking</div></div> : null}
                                                        {activityQuestion &&
                                                          activityQuestion.question_answers &&
                                                          (() => {
                                                            let serialNumber = 0 // Separate counter for serial number
                                                            const answers = activityQuestion.english_question_part_answer_type === 4
                                                            ? rearrangeEvenOdd(activityQuestion.question_answers)
                                                            : activityQuestion.question_answers || [];
                                                            // return rearrangeEvenOdd(
                                                            //   activityQuestion.question_answers
                                                            // ).map(
                                                              return answers.map((
                                                                activityQuestionAns,
                                                                indexQuestionAns
                                                              ) => {
                                                                if (
                                                                  activityQuestionAns &&
                                                                  activityQuestionAns.english_answer_text
                                                                ) {
                                                                  const cleanText = activityQuestionAns.english_answer_text
                                                                  .replace(/&nbsp;/g, '')
                                                                  .replace(/`/g, '')
                                                                  .replace(/<[^>]*>/g, '')
                                                                  .trim();
                
                                                                    const hasImage = /<img\s+[^>]*>/gi.test(activityQuestionAns.english_answer_text);
                      
                                                                    if (!cleanText && !hasImage) {
                                                                        return null; // Skip rendering if english_answer_text is effectively empty and no image is present
                                                                    }
                                                                  serialNumber++ // Increment serial number only if answer text is valid

                                                                  return (
                                                                    <li
                                                                      key={
                                                                        indexQuestionAns
                                                                      }
                                                                      className={
                                                                        activityQuestionAns.english_answer_is_correct ==
                                                                        1
                                                                          ? "selector-display"
                                                                          : ""
                                                                      }
                                                                    >
                                                                      {activityQuestion.english_question_part_answer_type === 4 ?
                                                                      <div className="p-2 px-3 font-size-18">
                                                                        {
                                                                          serialNumber
                                                                        }
                                                                      </div>
                                                                      : null}
                                                                      <div className="p-2 px-3 dg-media border-start-display">
                                                                        <div
                                                                          dangerouslySetInnerHTML={{
                                                                            __html:
                                                                              activityQuestionAns.english_answer_text,
                                                                          }}
                                                                        />
                                                                      </div>
                                                                    </li>
                                                                  )
                                                                }

                                                                return null // Skip if answer text is null
                                                              }
                                                            )
                                                          })()}
                                                      </ul>
                                                    </>
                                                  )}
                                              
                                                {activity.question_details &&
                                                  activity.question_details
                                                    .english_question_new_category &&
                                                  (parseInt(
                                                    activity.question_details
                                                      .english_question_new_category
                                                      .english_question_category_id
                                                  ) === 13 ||
                                                    parseInt(
                                                      activity.question_details
                                                        .english_question_new_category
                                                        .english_question_category_id
                                                    ) === 10) && (
                                                    <>
                                                      {/* <ul className="dg-selector list-unstyled mb-0 pt-4"> */}
                                                      <div class="q_a-preview pt-3 d-flex justify-content-between align-items-center">
                                                        {activityQuestion &&
                                                        activityQuestion.english_question_part_text ? (
                                                          <div
                                                            dangerouslySetInnerHTML={{
                                                              __html:
                                                                activityQuestion.english_question_part_text
                                                                  .replace(
                                                                    /\[(\d+)Answer char=\d+\]/g,
                                                                    ""
                                                                  )
                                                                  .replace(
                                                                    /\[Answer char=\d+\]/g,
                                                                    ""
                                                                  )
                                                                  .replace(
                                                                    /\[\[(.+?)\]\]/g,
                                                                    function (
                                                                      match,
                                                                      p1
                                                                    ) {
                                                                      return p1.length >
                                                                        1
                                                                        ? `<span class="text-bg-yellow">${p1}</span>`
                                                                        : `<span class="text-bg-blue">${p1}</span>`
                                                                    }
                                                                  )
                                                                  .replace(
                                                                    /\{\{/g,
                                                                    "<u>"
                                                                  )
                                                                  .replace(
                                                                    /\}\}/g,
                                                                    "</u>"
                                                                  ),
                                                            }}
                                                          />
                                                        ) : (
                                                          ""
                                                        )}
                                                        {/* <div className="">{activityQuestion.english_question_part_text} </div> */}
                                                        
                                                        {activityQuestion &&
                                                          activityQuestion.question_answers &&
                                                          activityQuestion
                                                            .question_answers
                                                            .length > 0 &&
                                                          activityQuestion
                                                            .question_answers[0]
                                                            .english_answer_text &&
                                                          activityQuestion
                                                            .question_answers[0]
                                                            .english_answer_text !=
                                                            "" &&
                                                          activityQuestion.question_answers.map(
                                                            (
                                                              activityQuestionAns,
                                                              indexQuestionAns
                                                            ) => (
                                                              <div>
                                                              {parseInt(activityQuestion.english_question_part_automark) === 0? <div className="d-flex justify-content-end mb-2"><div className="badge bg-primary text-white font-size-12 mb-0" style={{color: 'white'}}>Manual Marking</div></div> : null}
                                                              <div
                                                                className={
                                                                  activityQuestionAns &&
                                                                  activityQuestionAns.english_answer_text
                                                                    ? " myresult "
                                                                    : ""
                                                                }
                                                              >
                                                                {/* <div className="p-2 px-3 px-3 font-size-18">{indexQuestionAns + 1}</div> */}
                                                                
                                                                <div
                                                                  className="p-2 px-3 dg-media input_box small_input_box "
                                                                  style={{
                                                                    border:
                                                                      "groove",
                                                                    padding:
                                                                      "10px",
                                                                  }}
                                                                >
                                                                  {activityQuestionAns &&
                                                                  activityQuestionAns.english_answer_text ? (
                                                                    <div
                                                                      dangerouslySetInnerHTML={{
                                                                        __html:
                                                                          activityQuestionAns.english_answer_text,
                                                                      }}
                                                                    />
                                                                  ) : (
                                                                    ""
                                                                  )}
                                                                </div>
                                                              </div>
                                                              </div>
                                                            )
                                                          )}
                                                      </div>
                                                      {/* </ul> */}
                                                    </>
                                                  )}
                                              </>
                                            )
                                          )}
                                        </div>
                                      </div>
                                      {/* <div className="btn-group d-flex justify-content-between mt-3">
                                        <div>
                                          {parseInt(customActiveTab1) !== 0 && (
                                            <Button
                                              className="btn d-inline-block cs-btn-danger mt-1"
                                              onClick={goToPrevTab}
                                            >
                                              Prev
                                            </Button>
                                          )}
                                        </div>
                                        <div>
                                          {parseInt(customActiveTab1) !==
                                            popupPreviewSummativeData.length -
                                              1 && (
                                            <Button
                                              className="btn cs-btn-danger mt-1"
                                              onClick={goToNextTab}
                                            >
                                              Next
                                            </Button>
                                          )}
                                        </div>
                                      </div> */}
                                       <div className="btn-group d-flex justify-content-between mt-3">
                                        {/* Left Button (Prev) */}
                                        <div className={parseInt(customActiveTab1) !== 0 ? "" : "invisible"}>
                                          <Button className="btn d-inline-block cs-btn-danger mt-1" onClick={goToPrevTab}>
                                            Prev
                                          </Button>
                                        </div>

                                        {/* Middle Button (Replace) */}
                                        <div className="text-center">
                                          <Button className="btn d-inline-block cs-btn-danger mt-1" onClick={fetchReplaceData}>
                                            Replace
                                          </Button>
                                        </div>

                                        {/* Right Button (Next) */}
                                        <div
                                          className={
                                            parseInt(customActiveTab1) !== parseInt(popupPreviewSummativeData.length) - 1
                                              ? ""
                                              : "invisible"
                                          }
                                        >
                                          <Button className="btn d-inline-block cs-btn-danger mt-1" onClick={goToNextTab}>
                                            Next
                                          </Button>
                                        </div>
                                      </div>
                                      <div className="btn-group d-flex justify-content-center mt-4"> 
                                        <div>
                                          <Button
                                            className="btn d-inline-block cs-btn-danger mt-1"
                                            color="danger"
                                            disabled={
                                              !Array.isArray(existingData) || existingData.length == 0
                                            }
                                          
                                            onClick={() => tog_large()}
                                          >
                                            Create Summative Activity
                                          </Button>
                                        </div>
                                      </div>
                                    </div>
                                  </TabPane>
                                )
                              )}
                          </TabContent>
                        </div>
                      </Container>
                    )}
                    {subjectIdData === 2 && (
                      <Container className="custom-wt">
                        <div className="assessement-section assessment-width-hold">
                          <Nav tabs className="md-prev-tab mb-3">
                            {
                              
                              popupPreviewSummativeData &&
                                popupPreviewSummativeData.length > 0 &&
                                popupPreviewSummativeData.map(
                                  (activity, popactivityindex) => (
                                    <NavItem key={popactivityindex}>
                                      <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={
                                          classnames({
                                            active:
                                              customActiveTab1 ===
                                              popactivityindex.toString(),
                                          }) + " display-number"
                                        }
                                        onClick={() =>
                                          toggleCustom1(
                                            popactivityindex.toString()
                                          )
                                        }
                                      >
                                        <span className="font-size-20 fw-800">
                                          {popactivityindex + 1}
                                        </span>
                                      </NavLink>
                                    </NavItem>
                                  )
                                )
                            }
                          </Nav>

                          <TabContent
                            activeTab={customActiveTab1}
                            className="text-muted question_container"
                          >
                            {popupPreviewSummativeData &&
                              popupPreviewSummativeData.length > 0 &&
                              popupPreviewSummativeData.map(
                                (activity, popactivityindex) => (
                                  <TabPane
                                    tabId={popactivityindex.toString()}
                                    key={popactivityindex}
                                  >
                                    {" "}
                                    <div className="hw-list mt-4 pb-100">
                                      {activity &&
                                      activity.question_details &&
                                      activity.question_details.question_text &&
                                      activity.question_details.question_text
                                        .trim()
                                        .toString() != "" ? (
                                        <div class="QuestionBody jss13 mb-5">
                                          <div>
                                            {" "}
                                            {activity.question_details &&
                                            activity.question_details.question_text ? (
                                              <div
                                                dangerouslySetInnerHTML={{
                                                  __html:
                                                    activity.question_details.question_text
                                                      .replace(
                                                        /\[(\d+)Answer char=\d+\]/g,
                                                        ""
                                                      )
                                                      .replace(
                                                        /\[Answer char=\d+\]/g,
                                                        ""
                                                      ),
                                                }}
                                              />
                                            ) : (
                                              ""
                                            )}{" "}
                                          </div>
                                        </div>
                                      ) : null}

                                      {activity &&
                                        activity.question_details &&
                                        activity.question_details.question_parts &&
                                        activity.question_details.question_parts.map(
                                          activityQuestion => (
                                            <>
                                              <div class="QuestionBody jss13">
                                                <div>
                                                  {activityQuestion &&
                                                  activityQuestion.part_text ? (
                                                    <div
                                                      dangerouslySetInnerHTML={{
                                                        __html:
                                                          activityQuestion.part_text
                                                            .replace(
                                                              /\[(\d+)Answer char=\d+\]/g,
                                                              ""
                                                            )
                                                            .replace(
                                                              /\[Answer char=\d+\]/g,
                                                              ""
                                                            ),
                                                      }}
                                                    />
                                                  ) : (
                                                    ""
                                                  )}
                                                </div>
                                              </div>
                                             
                                              {activityQuestion &&
                                                activityQuestion.part_answer_type ==
                                                  4 && (
                                                  <ul className="dg-selector list-unstyled mb-0 pt-4">
                                                    {activityQuestion &&
                                                      activityQuestion.question_answers &&
                                                      (() => {
                                                        let serialNumber = 0 // Separate counter for serial number
                                                        return rearrangeEvenOdd(
                                                          activityQuestion.question_answers
                                                        ).map(
                                                          (
                                                            activityQuestionAns,
                                                            indexQuestionAns
                                                          ) => {
                                                            if (
                                                              activityQuestionAns &&
                                                              activityQuestionAns.answer_text
                                                            ) {
                                                              const cleanText = activityQuestionAns.answer_text
                                                              .replace(/&nbsp;/g, '')
                                                              .replace(/`/g, '')
                                                              .replace(/<[^>]*>/g, '')
                                                              .trim();
            
                                                                const hasImage = /<img\s+[^>]*>/gi.test(activityQuestionAns.answer_text);
                  
                                                                if (!cleanText && !hasImage) {
                                                                    return null; // Skip rendering if english_answer_text is effectively empty and no image is present
                                                                }
            
                                                              serialNumber++ // Increment serial number only when answer text is valid

                                                              return (
                                                                <li
                                                                  key={
                                                                    indexQuestionAns
                                                                  }
                                                                  className={
                                                                    activityQuestionAns.answer_is_correct &&
                                                                    activityQuestionAns.answer_is_correct ==
                                                                      1
                                                                      ? "selector-display"
                                                                      : ""
                                                                  }
                                                                >
                                                                  <div className="p-2 px-3 font-size-18">
                                                                    {
                                                                      serialNumber
                                                                    }
                                                                  </div>
                                                                  <div className="p-2 px-3 dg-media border-start-display">
                                                                    {activityQuestionAns &&
                                                                    activityQuestionAns.answer_text ? (
                                                                      <div
                                                                        dangerouslySetInnerHTML={{
                                                                          __html:
                                                                            activityQuestionAns.answer_text,
                                                                        }}
                                                                      />
                                                                    ) : (
                                                                      ""
                                                                    )}
                                                                  </div>
                                                                </li>
                                                              )
                                                            }

                                                            return null // Skip if answer_text is null
                                                          }
                                                        )
                                                      })()}
                                                  </ul>
                                                )}
                                              {activityQuestion &&
                                                activityQuestion.part_answer_type ==
                                                  2 && (
                                                    <div className="d-flex justify-content-end p-0">
                                                      <ul className="dg-selector list-unstyled mb-0 pt-4 w-25 ">
                                                        {activityQuestion &&
                                                          activityQuestion.question_answers &&
                                                          activityQuestion.question_answers.map(
                                                            (
                                                              activityQuestionAns,
                                                              indexQuestionAns
                                                            ) =>
                                                              activityQuestionAns &&
                                                              activityQuestionAns.answer_text ? (
                                                                <li className="selector-display-parttype-2">
                                                                  <div className="p-2 px-3 dg-media ">
                                                                    {activityQuestionAns &&
                                                                    activityQuestionAns.answer_text ? (
                                                                      <div
                                                                        dangerouslySetInnerHTML={{
                                                                          __html:
                                                                            activityQuestionAns.answer_text,
                                                                        }}
                                                                      />
                                                                    ) : (
                                                                      ""
                                                                    )}
                                                                  </div>
                                                                </li>
                                                              ) : null
                                                          )}
                                                      </ul>
                                                    </div>
                                                )}
                                            </>
                                          )
                                        )}

                                      {/* <div className="btn-group d-flex justify-content-between mt-3">
                                        <div>
                                          {parseInt(customActiveTab1) !== 0 && (
                                            <Button
                                              className="btn d-inline-block cs-btn-danger mt-1"
                                              onClick={goToPrevTab}
                                            >
                                              Prev
                                            </Button>
                                          )}
                                        </div>
                                        <div>
                                        
                                            <Button
                                              className="btn d-inline-block cs-btn-danger mt-1"
                                              onClick={ReplaceQus}
                                            >
                                              Replace
                                            </Button>
                                        
                                        </div>
                                        <div>
                                          {parseInt(customActiveTab1) !==
                                            parseInt(
                                              popupPreviewSummativeData
                                                .length
                                            ) -
                                              1 && (
                                            <Button
                                              className="btn cs-btn-danger mt-1"
                                              onClick={goToNextTab}
                                            >
                                              Next
                                            </Button>
                                          )}
                                        </div>
                                      </div> */}
                                      <div className="btn-group d-flex justify-content-between mt-3">
                                        {/* Left Button (Prev) */}
                                        <div className={parseInt(customActiveTab1) !== 0 ? "" : "invisible"}>
                                          <Button className="btn d-inline-block cs-btn-danger mt-1" onClick={goToPrevTab}>
                                            Prev
                                          </Button>
                                        </div>

                                        {/* Middle Button (Replace) */}
                                        <div className="text-center">
                                          <Button className="btn d-inline-block cs-btn-danger mt-1" onClick={fetchReplaceData} >
                                            Replace
                                          </Button>
                                        </div>

                                        {/* Right Button (Next) */}
                                        <div
                                          className={
                                            parseInt(customActiveTab1) !== parseInt(popupPreviewSummativeData.length) - 1
                                              ? ""
                                              : "invisible"
                                          }
                                        >
                                          <Button className="btn d-inline-block cs-btn-danger mt-1" onClick={goToNextTab}>
                                            Next
                                          </Button>
                                        </div>
                                      </div>

                                      <div className="btn-group d-flex justify-content-center mt-4"> 
                                        <div>
                                          <Button
                                            className="btn d-inline-block cs-btn-danger mt-1"
                                            color="danger"
                                            disabled={
                                              !Array.isArray(existingData) || existingData.length == 0
                                            }
                                          
                                            onClick={() => tog_large()}
                                          >
                                            Create Summative Activity
                                          </Button>
                                        </div>
                                      </div>

                                    </div>
                                  </TabPane>
                                )
                              )}
                          </TabContent>
                        </div>
                      </Container>
                    )}
                  </ModalBody>
                </>
              ) : (
                ""
              )}
            </MathJax>
          </Modal>

           
        </div>
      </Container>
    </React.Fragment>
  )
}

CreateSummative.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(CreateSummative)
